export const ONBOARD_LOCATIONS = 'onboard-locations'

export const LOCATIONS_NAME = 'locations'

export const POS_NAME = 'pos'
